import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import nl from '../locales/nl.json';
import fr from '../locales/fr.json';
import de from '../locales/de.json';
import en from '../locales/en.json';

export const initI18n = async () => {
  if (i18n.isInitialized) {
    return i18n;
  }

  await i18n
    .use(initReactI18next)
    .init({
      resources: {
        nl: { translation: nl },
        fr: { translation: fr },
        de: { translation: de },
        en: { translation: en },
      },
      
      fallbackLng: 'en',
      supportedLngs: ['nl', 'fr', 'de', 'en'],
      lng: 'en',
      debug: true,
      
      interpolation: {
        escapeValue: false,
      },
    });

  return i18n;
};

export default i18n;